import React from "react";
import { Link } from "react-router-dom";

export default function FeaturesGrid({
  eyebrow,
  title,
  subtitle,
  features = [],
  columns = 3,
  cta,
}) {
  const gridCols =
    columns === 2 ? "md:grid-cols-2" : columns === 4 ? "md:grid-cols-2 lg:grid-cols-4" : "md:grid-cols-3";

  return (
    <section className="eb-section bg-white">
      <div className="eb-container">
        <div className="max-w-2xl">
          {eyebrow ? <div className="eb-pill">{eyebrow}</div> : null}
          <h2 className="mt-4 eb-h2">{title}</h2>
          {subtitle ? <p className="mt-4 text-lg eb-muted">{subtitle}</p> : null}
        </div>

        <div className={["mt-10 grid gap-6", gridCols].join(" ")}>
          {features.map((f) => (
            <div key={f.title} className="eb-card p-6">
              <div className="flex items-start gap-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-brand-50 text-brand-800">
                  {f.icon ? <f.icon className="h-5 w-5" aria-hidden="true" /> : <span className="h-2 w-2 rounded-full bg-brand-700" />}
                </div>
                <div>
                  <h3 className="text-base font-semibold text-slate-900">{f.title}</h3>
                  {f.description ? <p className="mt-2 text-sm text-slate-600">{f.description}</p> : null}
                  {f.to ? (
                    <div className="mt-3">
                      <Link className="eb-link text-sm" to={f.to}>
                        Learn more
                      </Link>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>

        {cta ? (
          <div className="mt-10">
            <Link to={cta.to} className="eb-btn-primary">
              {cta.label}
            </Link>
          </div>
        ) : null}
      </div>
    </section>
  );
}

